/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { useTranslation } from "react-i18next";
import { useFlag } from "@unleash/proxy-client-react";
import { OptionTypeBase } from "../types/common";

export enum AnonymizeValues {
  RETAIN_DEVICE = "RETAIN_DEVICE",
  RETAIN_LONGITUDINAL = "RETAIN_LONGITUDINAL",
  RETAIN_INSTITUTION = "RETAIN_INSTITUTION",
  RETAIN_RETAIN_UIDS = "RETAIN_RETAIN_UIDS",
  RETAIN_DESCRIPTIONS_OPTION = "RETAIN_DESCRIPTIONS_OPTION",
  RETAIN_BURNED_IN_ANNOTATIONS_OPTION = "RETAIN_BURNED_IN_ANNOTATIONS_OPTION",
}

const useAnonymizeDropdown = (): Array<OptionTypeBase> => {
  const { t } = useTranslation("configuration");
  const enabledExcludeBurnedInAnnotations = useFlag(
    "anonymize-exclude-burned-in-annotations"
  );
  return [
    {
      label: t("anonymize.retain_device_identity_option"),
      value: AnonymizeValues.RETAIN_DEVICE,
    },
    {
      label: t(
        "anonymize.retain_longitudinal_temporal_information_full_dates_option"
      ),
      value: AnonymizeValues.RETAIN_LONGITUDINAL,
    },
    {
      label: t("anonymize.retain_institution_identity_option"),
      value: AnonymizeValues.RETAIN_INSTITUTION,
    },
    {
      label: t("anonymize.retain_uids_option"),
      value: AnonymizeValues.RETAIN_RETAIN_UIDS,
    },
    {
      label: t("anonymize.retain_descriptions_option"),
      value: AnonymizeValues.RETAIN_DESCRIPTIONS_OPTION,
    },
    ...(enabledExcludeBurnedInAnnotations
      ? [
          {
            label: t("anonymize.retain_burned_in_annotations_option"),
            value: AnonymizeValues.RETAIN_BURNED_IN_ANNOTATIONS_OPTION,
          },
        ]
      : []),
  ];
};

export default useAnonymizeDropdown;
